/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { artifactsControllerFindAll } from "./artifactsControllerFindAll";
import { artifactsControllerFindOne } from "./artifactsControllerFindOne";
import { artifactsControllerGetDownloadUrl } from "./artifactsControllerGetDownloadUrl";
import { artifactsControllerGetFileContent } from "./artifactsControllerGetFileContent";
import { artifactsControllerGetFolderFileContent } from "./artifactsControllerGetFolderFileContent";
import { artifactsControllerGetFolderFileDownloadUrl } from "./artifactsControllerGetFolderFileDownloadUrl";
import { artifactsControllerGetNutrientConfig } from "./artifactsControllerGetNutrientConfig";
import { artifactsControllerGetPagedArtifactPage } from "./artifactsControllerGetPagedArtifactPage";
import { artifactsControllerListFolderContents } from "./artifactsControllerListFolderContents";
import { documentArtifactsControllerFindAllByDocument } from "./documentArtifactsControllerFindAllByDocument";

export function documentArtifactsService() {
  return { artifactsControllerFindAll, artifactsControllerFindOne, artifactsControllerGetFileContent, artifactsControllerGetPagedArtifactPage, artifactsControllerGetDownloadUrl, artifactsControllerGetNutrientConfig, artifactsControllerListFolderContents, artifactsControllerGetFolderFileContent, artifactsControllerGetFolderFileDownloadUrl, documentArtifactsControllerFindAllByDocument }
}